import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailSlots } from '../../../../../slots/context.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import { isOneColConfigurator } from '../../types/typeguards.js';

const CLDeliveryIndicator = ()=>{
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    const { activeVariant  } = useProductData();
    const { state , selectors  } = useCLEcommContext();
    const { configurations , queries  } = state;
    const isLoading = !!selectors.hasQueryLoading(state);
    const deliveryItems = [];
    if (isOneColConfigurator(state)) {
        if (queries.both.sku && configurations.both.quantity) {
            deliveryItems.push({
                sku: queries.both.sku,
                quantity: configurations.both.quantity
            });
        }
    } else {
        if (queries.left.sku && configurations.left.quantity) {
            deliveryItems.push({
                sku: queries.left.sku,
                quantity: configurations.left.quantity
            });
        }
        if (queries.right.sku && configurations.right.quantity) {
            deliveryItems.push({
                sku: queries.right.sku,
                quantity: configurations.right.quantity
            });
        }
    }
    return Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React__default.createElement(Slots.DynamicDeliveryIndicator, {
        showLoader: isLoading,
        deliveryItems: deliveryItems,
        isExcludedFromCheckout: activeVariant.isExcludedFromCheckout,
        fallbackLabel: getLabel('products.deliveryIndicator.selectPrescription')
    }) : null;
};

export { CLDeliveryIndicator };
//# sourceMappingURL=CLDeliveryIndicator.js.map
